<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title> Reporte de Efectivos por {{ menu_name }} </v-card-title>
      <v-card-text>
        <v-row align="center">
          <v-col cols="12" md="6" sm="6">
            <v-combobox v-model="sede" :items="sedes" item-text="nombre" filled label="Sede"></v-combobox>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <v-combobox v-model="year" :items="gestiones" item-text="gestion" filled label="Gestion Año"></v-combobox>
          </v-col>
          <!-- this if for tabs for categories -->
          <v-col cols="12">
            <v-tabs v-model="tab" color="primary" centered grow slider-color="yellow">
              <v-tab v-for="(category, index) in categories" :key="index"> {{ category.nombre }} {{ category.postgrados.length }} </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item v-for="(category, index) in categories" :key="index">
                <v-card flat>
                  <v-card-text>
                    <template>
                      <v-data-table
                        :headers="headers"
                        :items="filterByCategory(programas, category.id)"
                        :search="search"
                        show-expand
                        :single-expand="true"
                        @item-expanded="loadDetails"
                      >
                        <!-- search box -->
                        <template v-slot:top>
                          <v-text-field v-model="search" label="Buscar.." class="mx-4" filled></v-text-field>
                        </template>
                        <!-- expand column -->
                        <template v-slot:[`item.data-table-expand`]="{ isExpanded, expand }">
                          <v-btn @click="expand(true)" v-if="!isExpanded" icon> <v-icon color="amber">mdi-arrow-down-circle</v-icon></v-btn>
                          <v-btn @click="expand(false)" v-if="isExpanded" icon> <v-icon color="red">mdi-arrow-up-circle</v-icon></v-btn>
                        </template>

                        <!-- subtable -->
                        <template v-slot:expanded-item="{ headers }">
                          <td :colspan="headers.length">
                            <v-skeleton-loader :loading="!modulos.length ? true : false" transition="scale-transition" height="100" type="table">
                              <v-data-table
                                :sort-by.sync="sortBy"
                                :headers="modulosHeaders"
                                :items="modulos"
                                item-key="id"
                                hide-default-footer
                                class="sub-table elevation-1"
                              ></v-data-table>
                            </v-skeleton-loader>
                          </td>
                        </template>
                      </v-data-table>
                    </template>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
          <v-col cols="12"> </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import xaxios from '@/xaxios';
import gql from 'graphql-tag';
import { parseEstadoPrograma } from '@/components/Utils.js';
import { mapState } from 'vuex';
export default {
  data() {
    return {
      tab: null,
      menu_name: process.env.VUE_APP_NAME_MENU,
      api_rest: process.env.VUE_APP_API_REST,
      sede: null,
      year: null,
      search: '',
      sortBy: 'id',
      programas: [],
      headers: [
        { text: 'Programa', value: 'postgrado.nombre', width: 300 },
        { text: 'Area', value: 'postgrado.area.nombre' },
        { text: 'Gestion', value: 'gestion' },
        { text: 'Version', value: 'version', sortable: false },
        { text: 'Grupo', value: 'grupo' },
        { text: 'Estado', value: 'fase' },
        { text: 'Coordinador', value: '' }, // TODO: falta este campo
        { text: 'Responsable', value: '' }, // TODO: falta este campo
        { text: 'Universidad', value: 'universidad.nombre', width: 200 },
      ],
      modulos: [],
      modulosHeaders: [
        { text: 'ID', value: 'id' },
        { text: 'Modulo', value: 'modulo.nombre', width: 300 },
        { text: 'Fecha Inicio', value: 'inicio', width: 120, align: 'center' },
        { text: 'Fecha Fin', value: 'fin', width: 120, align: 'center' },
        { text: 'Estado', value: 'estado' },
        // { text: 'Preinscritos', value: 'preinscritos' },
        { text: 'Inscritos', value: 'inscritos' },
        { text: 'Imcorporados', value: 'incorporados' },
        { text: 'Retirados', value: 'retirados' },
        { text: 'Congelados', value: 'congelados' },
        { text: 'Aprobados', value: 'aprobados' },
        { text: 'Reprobados', value: 'reprobados' },
        { text: 'Efectivos', value: 'efectivos' },
      ],
    };
  },
  computed: {
    ...mapState({
      UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
      cargo_sede: (state) => state.cargo_sede,
      sedes: (state) => (state.UNIDAD_NEGOCIO_ID ? state.modsede.items.filter((item) => item.unidad_negocio == state.UNIDAD_NEGOCIO_ID) : []),
      gestion: (state) => state.gestion.value,
      gestiones: (state) => state.gestion.items,
      categories: (state) => state.categoria.items,
    }),
  },
  watch: {
    sede: async function (val) {
      this.loadGetProgramas();
      return val;
    },
    year: function (val) {
      this.loadGetProgramas();
      return val;
    },
    UNIDAD_NEGOCIO_ID() {
      // reload();
    },
  },
  methods: {
    // cheackdata({ item, value }) {
    //   if (value) window.console.log('click expanded cheackdata', item);
    // },
    filterByCategory(programas, categoria_id) {
      return programas.filter((programa) => programa.postgrado.categoria.id == categoria_id);
    },
    loadDetails({ item, value }) {
      this.modulos = [];
      if (value) {
        let { programa_modulos, inscripciones } = item;
        let id = null;

        programa_modulos.sort((a, b) => a.id - b.id);
        programa_modulos.forEach((modulo) => {
          modulo.preinscritos = 0;
          if (!id) {
            id = modulo.id;
            modulo.preinscritos = inscripciones.length;
          }
          modulo.inscritos = 0;
          modulo.incorporados = 0;
          modulo.aprobados = 0;
          modulo.reprobados = 0;
          modulo.retirados = 0;
          modulo.congelados = 0;
          modulo.efectivos = 0;

          const url = `${this.api_rest}/esam/inscripcion/modulo/id/${modulo.id}`;
          xaxios
            .get(url)
            .then(({ data }) => {
              data.forEach((student) => {
                student.tipo_ingreso ? modulo.incorporados++ : modulo.inscritos++;
                if (student.estado_inscripcion == 1 || student.estado_inscripcion == 2) {
                  student.estado_inscripcion == 1 ? modulo.retirados++ : null;
                  student.estado_inscripcion == 2 ? modulo.congelados++ : null;
                } else {
                  student.nota_final > 50 || student.nota_recuperatorio > 50 ? modulo.aprobados++ : modulo.reprobados++;
                }
                modulo.efectivos = modulo.inscritos + modulo.incorporados - modulo.retirados - modulo.reprobados - modulo.congelados;
              });
              // aqui se teine que incluid a modulos con los datos actualizados
              this.modulos.push(modulo);
            })
            .catch(({ response }) => {
              // aqui se teine que incluid a modulos con los datos en 0
              window.console.log(`ERROR: ${response.data},`);
              this.modulos.push(modulo);
            });
        });
      }
    },
    parseEfectivosByModule(modulos, preinscritos) {
      window.console.log('data view enrolls', modulos, preinscritos);
      let i = 0,
        inscritos = 0,
        incorporados = 0,
        aprobados = 0,
        reprobados = 0,
        retirados = 0,
        congelados = 0,
        efectivos = 0;

      modulos.map(async (modulo) => {
        // this line eexecution call all student for module
        if (modulo) {
          await xaxios
            .get(`${this.api_rest}/esam/inscripcion/modulo/id/${modulo.id}`)
            .then(({ data }) => {
              // window.console.log('data view enrolls', data);
              data.forEach((student) => {
                i++;
                student.tipo_ingreso ? incorporados++ : inscritos++;
                if (student.estado_inscripcion == 1 || student.estado_inscripcion == 2) {
                  student.estado_inscripcion == 1 ? retirados++ : null;
                  student.estado_inscripcion == 2 ? congelados++ : null;
                } else {
                  student.nota_final > 50 || student.nota_recuperatorio > 50 ? aprobados++ : reprobados++;
                }
              });
            })
            .catch(() => {});
        }
        efectivos = inscritos + incorporados - retirados - reprobados - congelados;
        modulo.preinscritos = i === 1 ? preinscritos : 0;
        modulo.inscritos = inscritos;
        modulo.incorporados = incorporados;
        modulo.aprobados = aprobados;
        modulo.reprobados = reprobados;
        modulo.retirados = retirados;
        modulo.congelados = congelados;
        modulo.efectivos = efectivos;
        return modulo;
      });
      return modulos;
    },
    loadGetProgramas() {
      let gestion = this.gestion ? ',gestion:' + this.year.gestion : '';
      let sede = this.sede ? ',idsede:' + this.sede.idsede : '';
      if (gestion && sede) {
        const sql = gql`query { getProgramas(cursor:10000000,${gestion} ${sede}){ 
            id,fase,modalidad,version,grupo,gestion, estado,nombre_compuesto
            programa_modulos{id, inicio, fin, estado modulo{ id, nombre}},
            postgrado{nombre, categoria{id, nombre} area{nombre}}
            inscripciones{id}, universidad{nombre},
          }
        }`;
        // window.console.log(sql);
        this.$apollo
          .query({ query: sql })
          .then(({ data: { getProgramas } }) => {
            this.programas = getProgramas.sort((a, b) => a.postgrado.nombre.toUpperCase() < b.postgrado.nombre.toUpperCase());
            this.programas.map((programa) => {
              // programa.programa_modulos = this.parseEfectivosByModule(programa.programa_modulos, programa.inscripciones.length);
              programa.fase = parseEstadoPrograma(+programa.fase);
              return programa;
            });
            // window.console.log('this.programas', this.programas);
          })
          .catch(({ response }) => window.console.error('Error: Efectivos getProgramas ', response));
      }
    },
  },
  mounted() {
    this.sede = this.cargo_sede;
    this.year = this.gestion;
  },
};
// this is a help for add event every click for expanded row
// https://stackoverflow.com/questions/60993875/vuetify-data-tables-fetch-data-when-expanding-a-row
</script>

<style>
.sub-table.theme--light.v-data-table {
  background: transparent;
}
/* .sub-table .v-data-table-header {
  display: none;
} */
.v-data-table tbody tr.v-data-table__expanded__content {
  background: #d5e9fb;
}
</style>
